import { AsyncFetchRender } from "src/components/common/async/AsyncFetchRender.tsx";
import { SalvosCustomerOrderApi } from "src/api/generated/tenants/salvos/erp/sales/customerOrder/salvosCustomerOrderApi.ts";
import { LabelValueView } from "src/components/common/misc/LabelValueView.tsx";
import { VerticalBox } from "src/components/common/box/VerticalBox.tsx";
import { Typography } from "@mui/material";
import i18n from "i18next";
import { SalvosCustomerOrderTenantStateHistoryLineDto } from "src/api/generated/tenants/salvos/erp/sales/customerOrder/salvosCustomerOrderTenantStateHistoryLineDto.ts";

export interface SalvosCustomerOrderTenantStateHistoryViewProps {
	customerOrderId: number;
}

export const SalvosCustomerOrderTenantStateHistoryView = ({
	customerOrderId,
}: SalvosCustomerOrderTenantStateHistoryViewProps) => {
	return (
		<AsyncFetchRender
			fetch={async () =>
				await SalvosCustomerOrderApi.getCustomerOrderTenantStateHistory({
					customerOrderId: customerOrderId,
				})
			}
			content={(data) => (
				<VerticalBox
					sx={{
						padding: 2,
						minHeight: "auto",
						gap: 2,
					}}
				>
					<Typography
						variant={"h6"}
						sx={{
							fontWeight: "bold",
						}}
					>
						{i18n.t("state")}: {data.tenantStateLabel}
					</Typography>
					<LabelValueView
						items={[
							formatHistoryLine(i18n.t("salvos.order_saved"), data.orderCreated),
							formatHistoryLine(i18n.t("salvos.order_checked"), data.orderChecked),
							formatHistoryLine(i18n.t("salvos.order_confirmed"), data.orderConfirmed),
							formatHistoryLine(
								i18n.t("salvos.first_phase_planning_released"),
								data.firstPhasePlanningReleased,
							),
							formatHistoryLine(
								i18n.t("salvos.first_phase_planning_completed"),
								data.firstPhasePlanningCompleted,
							),
							formatHistoryLine(i18n.t("salvos.building_licence_received"), data.buildingLicenceReceived),
							formatHistoryLine(i18n.t("salvos.delivery_date_agreed"), data.deliveryDateAgreed),
							formatHistoryLine(
								i18n.t("salvos.second_phase_planning_released"),
								data.secondPhasePlanningReleased,
							),
							formatHistoryLine(
								i18n.t("salvos.second_phase_planning_completed"),
								data.secondPhasePlanningCompleted,
							),
							formatHistoryLine(i18n.t("salvos.released_to_production"), data.releasedToProduction),
							formatHistoryLine(i18n.t("salvos.marked_completed"), data.markedCompleted),
						]}
					/>
				</VerticalBox>
			)}
		/>
	);

	function formatHistoryLine(label: string, line: SalvosCustomerOrderTenantStateHistoryLineDto) {
		const value =
			line.modifiedAt != null && line.modifiedByUserName != null
				? `${line.modifiedAt}, ${line.modifiedByUserName}`
				: "-";
		return {
			label: label,
			value: value,
		};
	}
};
